import { render } from "./QuestionsAdmin.vue?vue&type=template&id=050d9817&scoped=true"
import script from "./QuestionsAdmin.vue?vue&type=script&lang=js"
export * from "./QuestionsAdmin.vue?vue&type=script&lang=js"

import "./QuestionsAdmin.vue?vue&type=style&index=0&id=050d9817&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-050d9817"]])

export default __exports__